module.exports = __webpack_public_path__ + "static/formenti-logo-afda064ffcb189f43783264307fd11ff.svg";